import './styles.scss';

import React, {useMemo} from 'react';

import {AlertTypeDTO} from 'kashable-mobile-common';

import {alertTitle} from '../../../../../../../utils/AlertUtil';
import {formatNotificationDate} from '../../../../../../../utils/DateUtil';
import {AlertIcon} from '../../../../../../AlertIcon/AlertIcon';

interface ModalAlertPreviewProps {
    data: AlertTypeDTO;
    onClick: () => void;
}

export const ModalAlertPreview = ({data, onClick}: ModalAlertPreviewProps) => {
    const className = useMemo(() => {
        return data.read ? 'modal-alert-preview' : `modal-alert-preview ${data.credit_monitoring_alert_type}`;
    }, [data]);
    const text = useMemo(() => {
        switch (data.credit_monitoring_alert_type) {
            case AlertTypeDTO.CreditMonitoringAlertType.NEW_ACCOUNT:
                return 'A new account was opened in the consumer\'s name';
            case AlertTypeDTO.CreditMonitoringAlertType.NEW_EMPLOYMENT:
                return 'New employment has been reported';
            case AlertTypeDTO.CreditMonitoringAlertType.NEW_ADDRESS:
                return 'A new address has been reported';
            case AlertTypeDTO.CreditMonitoringAlertType.NEW_PUBLIC_RECORD:
                return 'A new public record has been reported';
            case AlertTypeDTO.CreditMonitoringAlertType.NEW_INQUIRY:
                return 'A new credit inquiry has been reported';
            case AlertTypeDTO.CreditMonitoringAlertType.IMPROVED_ACCOUNT:
                return 'The status on an account has improved';
            case AlertTypeDTO.CreditMonitoringAlertType.DELINQUENT_ACCOUNT:
                return 'An account has been reported delinquent';
            case AlertTypeDTO.CreditMonitoringAlertType.BANKRUPTCY:
                return 'A bankruptcy has been reported';
            case AlertTypeDTO.CreditMonitoringAlertType.FRAUD_ALERT:
                return 'A fraud alerts has been reported';
            default:
                return '';
        }
    }, [data]);

    return (
        <div className={className} onClick={onClick}>
            <div className='modal-alert-preview__wrap'>
                <div className='modal-alert-preview__icon'>
                    <AlertIcon type={data.credit_monitoring_alert_type} />
                </div>
                <div className='modal-alert-preview__content'>
                    <div className='modal-alert-preview__head'>
                        <h3 className='modal-alert-preview__title'>
                            {alertTitle(data.credit_monitoring_alert_type)}
                        </h3>
                        <span className='modal-alert-preview__date'>
                            {formatNotificationDate(data.available_date)}
                        </span>
                    </div>
                    {text}
                </div>
            </div>
        </div>
    );
};
